import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'EnterWalletAddressesPage.title',
    defaultMessage: 'Enter your wallet addresses',
    description: 'Title for enter wallet addresses page',
  },
  description: {
    id: 'EnterWalletAddressesPage.description',
    defaultMessage: `Your wallet addresses must support Bitcoin, Bitcoin Cash, Dogecoin, and Litecoin assets.`,
    description: 'Description text prompting user to make sure wallet supports assets',
  },
  inputLabel: {
    id: 'EnterWalletAddressesPage.inputLabel',
    defaultMessage: '{asset} address',
    description: 'Input label for asset address',
  },
  inputPlaceholder: {
    id: 'EnterWalletAddressesPage.inputPlaceholder',
    defaultMessage: 'Enter your {asset} address',
    description: 'Input placeholder for asset address',
  },
  inputHelperText: {
    id: 'EnterWalletAddressesPage.inputHelperText',
    defaultMessage: 'Wallet address must support {asset}.',
    description: 'Input helper text for asset address',
  },
  back: {
    id: 'EnterWalletAddressesPage.back',
    defaultMessage: 'Back',
    description: 'Back button text',
  },
  continue: {
    id: 'EnterWalletAddressesPage.continue',
    defaultMessage: 'Continue',
    description: 'Continue button text',
  },
  loading: {
    id: 'EnterWalletAddressesPage.loading',
    defaultMessage: 'In Progress..',
    description: 'Withdrawal in progress',
  },
});
